export const SET_USER_NAME = 'SET_USER_NAME'
export const SET_USER_EMAIL = 'SET_USER_EMAIL'
export const SET_USER_ACTIVE_STATUS = 'SET_USER_ACTIVE_STATUS'
export const SET_USER_EXISTING = 'SET_USER_EXISTING'
